import axiosSync from "@/axiosSync";

export function useSwitchDetailsBdcomSwitchApi() {
  async function getBasicInfo(swid) {
    const response = await axiosSync.get(`/bdco_swicth?url=${process.env.VUE_APP_API_BASE_URL}&swid=${swid}`);
    return response.data;
  }
  async function getSfpInfoData(swid) {
    const response = await axiosSync.get(`/bdco_swicth?url=${process.env.VUE_APP_API_BASE_URL}&swid=${swid}&type=sfpinfo`);
    return response.data;
  }
  async function getSintfStateData(swid) {
    const response = await axiosSync.get(`/bdco_swicth?url=${process.env.VUE_APP_API_BASE_URL}&swid=${swid}&type=intfstate`);
    return response.data;
  }
  async function getPortUpdateVlaue(swid) {
    const response = await axiosSync.get(`/bdco_swicth?url=${process.env.VUE_APP_API_BASE_URL}&swid=${swid}&type=portupdatevlaue`);
    return response.data;
  }
  async function getPortDescription(swid) {
    const response = await axiosSync.get(`/bdco_swicth?url=${process.env.VUE_APP_API_BASE_URL}&swid=${swid}&type=portdecrption`);
    return response.data;
  }
  async function getSwitchOnOffVlaue(swid, intfenable, status) {
    const response = await axiosSync.get(`/bdco_swicth?url=${process.env.VUE_APP_API_BASE_URL}&swid=${swid}&type=actionport&intfenable=${intfenable}&status=${status}`);
    return response.data;
  }

  return {    
    getBasicInfo,
    getSfpInfoData,
    getSintfStateData,
    getPortUpdateVlaue,
    getPortDescription,
    getSwitchOnOffVlaue
  };
}
